import { loadPostHog } from './on_page_ready'
import posthog from 'posthog-js';

loadPostHog()
